import React, { useState ,useEffect} from "react";
import axios from "axios";
import "./VisionIgniteUPIMandate.css";

const VisionIgniteUPIMandate = () => {
   useEffect(() => {
       const navbar = document.querySelector("header, .navbar");
       const footer = document.querySelector("footer");
   
       if (navbar) navbar.style.display = "none";
       if (footer) footer.style.display = "none";
   
       return () => {
         if (navbar) navbar.style.display = "";
         if (footer) footer.style.display = "";
       };
     }, []);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [mandateData, setMandateData] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const scrollToJoin = () => {
    document.getElementById("join")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // Existing backend flow is preserved. Offer availability is checked by the
  // existing create-mandate controller; no new Offer GET request is added.
  const createMandate = async (event) => {
    event?.preventDefault();
    setError("");

    if (!formData.name.trim()) {
      setError("Please enter your full name.");
      scrollToJoin();
      return;
    }
    if (!formData.email.trim()) {
      setError("Please enter your email.");
      scrollToJoin();
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      setError("Please enter a valid email address.");
      scrollToJoin();
      return;
    }
    if (!formData.phone.trim()) {
      setError("Please enter your phone number.");
      scrollToJoin();
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "/api/razorpay/create-vision-ignite-upi-mandate",
        {
          name: formData.name.trim(),
          email: formData.email.trim().toLowerCase(),
          phone: formData.phone.trim(),
        }
      );

      const data = response.data;
      if (!data?.success) {
        throw new Error(data?.message || "Unable to create UPI mandate.");
      }

      const subscriptionId = data?.subscription?.id;
      if (!subscriptionId) {
        throw new Error("Razorpay subscription ID was not received.");
      }

      if (!window.Razorpay) {
        throw new Error("Razorpay Checkout SDK is not loaded.");
      }

      setMandateData(data.subscription);

      const checkout = new window.Razorpay({
        key: import.meta.env.VITE_RAZORPAY_KEY_ID,
        subscription_id: subscriptionId,
        name: "Forge Your Peak",
        description: "Vision Ignite monthly membership",
        prefill: {
          name: formData.name.trim(),
          email: formData.email.trim().toLowerCase(),
          contact: formData.phone.trim(),
        },
        notes: {
          service: "Forge Your Peak - Vision Ignite",
          product: "VISION_IGNITE",
        },
        theme: { color: "#0f5560" },
        handler: async (razorpayResponse) => {
          await verifyPayment(razorpayResponse);
        },
        modal: {
          ondismiss: () => setLoading(false),
        },
      });

      checkout.on("payment.failed", (checkoutResponse) => {
        setError(
          checkoutResponse?.error?.description ||
            "UPI mandate authorization failed. Please try again."
        );
        setLoading(false);
      });

      checkout.open();
    } catch (requestError) {
      console.error("Vision Ignite mandate error:", requestError);
      setError(
        requestError?.response?.data?.message ||
          requestError?.message ||
          "Something went wrong. Please try again."
      );
      setLoading(false);
    }
  };

  const verifyPayment = async (razorpayResponse) => {
    try {
      setVerifying(true);
      setError("");

      const response = await axios.post(
        "/api/razorpay/verify-vision-ignite-upi-autopay",
        {
          razorpaySubscriptionId:
            razorpayResponse?.razorpay_subscription_id,
          razorpayPaymentId: razorpayResponse?.razorpay_payment_id,
          razorpaySignature: razorpayResponse?.razorpay_signature,
          customerName: formData.name.trim(),
          customerEmail: formData.email.trim().toLowerCase(),
          customerPhone: formData.phone.trim(),
        }
      );

      const data = response.data;
      if (!data?.success) {
        throw new Error(data?.message || "UPI mandate verification failed.");
      }

      setMandateData(data?.data || null);
      setSuccess(true);
    } catch (verificationError) {
      console.error("Vision Ignite verification error:", verificationError);
      setError(
        verificationError?.response?.data?.message ||
          verificationError?.message ||
          "Payment verification failed."
      );
      document.getElementById("join")?.scrollIntoView({ behavior: "smooth" });
    } finally {
      setVerifying(false);
      setLoading(false);
    }
  };

  if (success) {
    return (
      <main className="vi-site">
        <div className="vi-wrap vi-success-wrap">
          <nav className="vi-nav">
            <a className="vi-logo" href="#top" aria-label="Vision Ignite home">
              Vision <span>Ignite</span>
            </a>
          </nav>
          <section className="vi-success-card" aria-live="polite">
            <div className="vi-success-icon">✓</div>
            <p className="vi-eyebrow">PAYMENT SETUP COMPLETE</p>
            <h1>Mandate Activated</h1>
            <p className="vi-lead">
              Your Vision Ignite UPI Autopay verification was successful.
            </p>
            <div className="vi-summary">
              <div><span>Plan</span><strong>Vision Ignite</strong></div>
              <div><span>Monthly membership</span><strong>₹1,500</strong></div>
              <div><span>Scheduled duration</span><strong>6 months</strong></div>
              <div><span>Plan total</span><strong>₹9,000</strong></div>
              {mandateData?.razorpaySubscriptionId && (
                <div className="vi-summary-id">
                  <span>Subscription ID</span>
                  <strong>{mandateData.razorpaySubscriptionId}</strong>
                </div>
              )}
              {mandateData?.razorpayPaymentId && (
                <div className="vi-summary-id">
                  <span>Payment ID</span>
                  <strong>{mandateData.razorpayPaymentId}</strong>
                </div>
              )}
              {mandateData?.status && (
                <div><span>Status</span><strong>{mandateData.status}</strong></div>
              )}
            </div>
            <p className="vi-small-note">
              Please keep the transaction details for your records.
            </p>
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="vi-site" id="top">
      <div className="vi-wrap">
        <nav className="vi-nav">
          <a className="vi-logo" href="#top" aria-label="Vision Ignite home">
            Vision <span>Ignite</span>
          </a>
          <button type="button" className="vi-btn vi-nav-btn" onClick={scrollToJoin}>
            Join now
          </button>
        </nav>

        <header className="vi-hero">
          <div className="vi-hero-grid">
            <div className="vi-hero-copy">
              <p className="vi-eyebrow">A NEW WAY TO CARE FOR YOUR VISION</p>
              <h1>Glasses for life, or surgery? Those aren't your only two options.</h1>
              <p className="vi-sub">Train your eyes daily. Reduce the strain. See clearer.</p>
              <p className="vi-description">
                10–15 minutes a day. Built around habits most people never knew they needed.
                A system for healthier, calmer and more resilient vision.
              </p>
              <button type="button" className="vi-btn" onClick={scrollToJoin}>
                Start at ₹1,500 / month
              </button>
              <p className="vi-price-line">
                Just ₹1,500 a month. Your first month also includes a one-time vision kit.
                Cancel anytime.
              </p>
              <blockquote className="vi-pull">
                <p>It's been 4 years, and I'm still glasses free.</p>
                <div className="vi-who">
                  <div className="vi-photo"><img src="/testimonials/aravindh.jpeg" alt="Aravindh" loading="lazy" /></div>
                  <cite>Aravindh, 26 · Engineer</cite>
                </div>
              </blockquote>
            </div>
            <div className="vi-focus" role="img" aria-label="Concentric rings representing calm visual focus">
              <i /><i /><i /><i /><b />
              <small>Breathe in. Look far.</small>
            </div>
          </div>
          <div className="vi-strip">
            <div><b>4.5D</b><span>to no glasses, Gowrisankar, 27</span></div>
            <div><b>4 years</b><span>and still glasses free, Aravindh, 26</span></div>
            <div><b>Cricketers</b><span>now playing without glasses</span></div>
          </div>
        </header>
      </div>

      <section className="vi-alt">
        <div className="vi-wrap">
          <h2>Five habits, one daily practice</h2>
          <p className="vi-lead">
            Each session blends these areas so your eyes get relief and training in the same 10–15 minutes.
          </p>
          <div className="vi-grid vi-g5">
            <article className="vi-pillar"><div className="vi-emoji">😌</div><h3>Eye Relaxation</h3><p>Palming, breath and nervous-system calming.</p></article>
            <article className="vi-pillar"><div className="vi-emoji">🔍</div><h3>Focus Flexibility</h3><p>Near-far shifting to reduce screen stiffness.</p></article>
            <article className="vi-pillar"><div className="vi-emoji">⛰️</div><h3>Distance Vision</h3><p>Rebuild the habit of looking far naturally.</p></article>
            <article className="vi-pillar"><div className="vi-emoji">🌀</div><h3>Visual Awareness</h3><p>Peripheral awareness and attention training.</p></article>
            <article className="vi-pillar"><div className="vi-emoji">☀️</div><h3>Recovery Habits</h3><p>Sleep, sunlight and screen breaks.</p></article>
          </div>
        </div>
      </section>

      <section>
        <div className="vi-wrap">
          <h2>Real members. Real change.</h2>
          <p className="vi-lead">
            Four people who started with glasses and a doubt. Here is where they are now, in their own words.
          </p>
          <div className="vi-grid vi-g2">
            <article className="vi-case">
              <div className="vi-stat">4.5D to none</div>
              <dl><dt>Before</dt><dd>Thick glasses, worn all his life</dd><dt>Today</dt><dd>No glasses, except as a fashion statement</dd></dl>
              <blockquote>I was wearing thick glasses of 4.5D all my life. Now I don't wear them for anything except as a fashion statement.</blockquote>
              <div className="vi-who"><div className="vi-photo"><img src="/testimonials/gowrisankar.jpg" alt="Gowrisankar" loading="lazy" /></div><cite>Gowrisankar <span>· 27 · IT Engineer</span></cite></div>
            </article>
            <article className="vi-case">
              <div className="vi-stat">4 years glasses free</div>
              <dl><dt>Before</dt><dd>Wanted to improve vision naturally</dd><dt>Today</dt><dd>Still glasses free, 4 years on</dd></dl>
              <blockquote>Forge Your Peak helped me improve my vision naturally. It's been 4 years, and I'm still glasses free.</blockquote>
              <div className="vi-who"><div className="vi-photo"><img src="/testimonials/aravindh.jpeg" alt="Aravindh" loading="lazy" /></div><cite>Aravindh <span>· 26 · Engineer</span></cite></div>
            </article>
            <article className="vi-case">
              <div className="vi-stat">Back on the pitch, no glasses</div>
              <dl><dt>Before</dt><dd>Glasses a menace while playing; weighing LASIK or contacts</dd><dt>Today</dt><dd>Plays without glasses</dd></dl>
              <blockquote>Wearing glasses while playing was a menace, was considering LASIK/contacts. Forge Your Peak was able to help reverse my eyesight naturally. Now I play without glasses, which I thought was impossible once.</blockquote>
              <div className="vi-who"><div className="vi-photo"><img src="/testimonials/aaditya.png" alt="Aaditya B" loading="lazy" /></div><cite>Aaditya B <span>· 22 · Cricketer</span></cite></div>
            </article>
            <article className="vi-case">
              <div className="vi-stat">Goodbye to glasses</div>
              <dl><dt>Before</dt><dd>Glasses on and off the field</dd><dt>Today</dt><dd>Glasses-free, and playing with confidence</dd></dl>
              <blockquote>I reversed my eyesight naturally and permanently said goodbye to my glasses. The team motivated me to go all the way and gave me the confidence to start playing without glasses.</blockquote>
              <div className="vi-who"><div className="vi-photo"><img src="/testimonials/girinath.jpeg" alt="Girinath Nagarajan" loading="lazy" /></div><cite>Girinath Nagarajan <span>· 21 · Cricketer</span></cite></div>
            </article>
          </div>
          <p className="vi-disclaimer">Individual experiences. Results vary from person to person.</p>
        </div>
      </section>

      <section className="vi-alt">
        <div className="vi-wrap">
          <h2>Who is this for?</h2>
          <p className="vi-lead">Anyone who spends their days looking at something close, from age 7 up.</p>
          <div className="vi-grid vi-g3">
            <article className="vi-aud"><div className="vi-emoji">🧒</div><h3>Children above 7</h3><p>Build healthy screen and distance-looking habits early, with routines simple enough for kids to follow.</p></article>
            <article className="vi-aud"><div className="vi-emoji">💼</div><h3>Working professionals</h3><p>Reduce screen strain after long workdays.</p><div className="vi-mini">“Now I don't wear them for anything except as a fashion statement.”<span>Gowrisankar, 27 · IT Engineer</span></div></article>
            <article className="vi-aud"><div className="vi-emoji">👨‍👩‍👧</div><h3>Families</h3><p>Healthy visual habits for the whole family, practised together.</p></article>
          </div>
        </div>
      </section>

      <section>
        <div className="vi-wrap">
          <h2>What's inside</h2>
          <p className="vi-lead">Everything you need to learn, practise and keep going.</p>
          <ol className="vi-steps">
            <li><div><h3>Eye Health Reset Core</h3><p>Understand how vision works and how strain builds.</p></div></li>
            <li><div><h3>Daily Vision Rituals</h3><p>Guided routines for daily eye health.</p></div></li>
            <li><div><h3>Visual Acuity Tracking</h3><p>Track improvements month by month.</p></div></li>
            <li><div><h3>Monthly Challenges</h3><p>Practice sprints that build consistency.</p></div></li>
            <li><div><h3>Community Access</h3><p>Share progress and get support.</p></div></li>
            <li><div><h3>Vision Kit</h3><p>Your starter kit, a one-time add-on with your first month.</p></div></li>
          </ol>
        </div>
      </section>

      <section className="vi-alt">
        <div className="vi-wrap">
          <h2>Who's teaching</h2>
          <div className="vi-teacher">
            <div className="vi-avatar"><img src="/Hero/Vevek-hero.jpeg" alt="Vevek Seetharaman" loading="lazy" /></div>
            <div>
              <h3>Vevek Seetharaman</h3>
              <div className="vi-role">Founder, Forge Your Peak</div>
              <p>Years spent working across vision, sports vision, neuro-athletic performance and the Bates Method led to one obsession:</p>
              <q>What parts of human visual performance can actually be measured and trained?</q>
              <p>That exploration became the Measure → Train → Transform methodology behind The Clear Vision Blueprint.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="join" className="vi-join">
        <div className="vi-wrap">
          <div className="vi-mid">
            <blockquote className="vi-pull">
              <p>The team motivated me to go all the way and gave me the confidence to start playing without glasses.</p>
              <div className="vi-who vi-centered"><div className="vi-photo"><img src="/testimonials/girinath.jpeg" alt="Girinath Nagarajan" loading="lazy" /></div><cite>Girinath Nagarajan, 21 · Cricketer</cite></div>
            </blockquote>
          </div>

          <div className="vi-price-card">
            <p className="vi-eyebrow">YOUR DAILY VISION ROUTINE</p>
            <h2>Join Vision Ignite</h2>
            <p>Monthly membership</p>
            <div className="vi-big">₹1,500<span> / month</span></div>
            <div className="vi-then">+ one-time vision kit with your first month</div>
            <ul>
              <li>Vision kit shipped with your first month (one-time ₹1,500)</li>
              <li>Daily 10–15 minute guided rituals</li>
              <li>Visual acuity tracking and monthly challenges</li>
              <li>Community access and support</li>
            </ul>

            <form className="vi-payment-form" onSubmit={createMandate}>
              <div className="vi-form-heading">
                <h3>Get started</h3>
                <p>Enter your details to set up monthly UPI Autopay.</p>
              </div>
              <label htmlFor="vi-name">Full name</label>
              <input id="vi-name" name="name" type="text" autoComplete="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} disabled={loading || verifying} />
              <label htmlFor="vi-email">Email address</label>
              <input id="vi-email" name="email" type="email" autoComplete="email" placeholder="you@example.com" value={formData.email} onChange={handleChange} disabled={loading || verifying} />
              <label htmlFor="vi-phone">Phone number</label>
              <input id="vi-phone" name="phone" type="tel" autoComplete="tel" placeholder="Enter your phone number" value={formData.phone} onChange={handleChange} disabled={loading || verifying} />

              {error && <div className="vi-error" role="alert">{error}</div>}

              <button type="submit" className="vi-btn vi-pay-btn" disabled={loading || verifying}>
                {loading ? "Opening secure checkout..." : verifying ? "Verifying payment..." : "Join Vision Ignite"}
              </button>
            </form>
            <p className="vi-fine">
              First payment: ₹3,000 (₹1,500 membership + ₹1,500 one-time vision kit). Every month after: ₹1,500. Cancel anytime.
            </p>
          </div>
        </div>
      </section>

      <section className="vi-alt">
        <div className="vi-wrap">
          <h2>Common questions</h2>
          <details><summary>Will this remove my glasses completely?</summary><p>The goal is to improve visual habits and reduce dependence where possible.</p></details>
          <details><summary>How much time does it take daily?</summary><p>Most routines take 10–15 minutes per day.</p></details>
          <details><summary>Is this only for athletes?</summary><p>No. Anyone can benefit from healthier vision habits.</p></details>
          <details><summary>Is it suitable for children?</summary><p>Yes. Children aged 7 and above can follow the routines.</p></details>
          <details><summary>How does the monthly membership work?</summary><p>The membership is ₹1,500 per month. Your first payment is ₹3,000 because it also includes a one-time vision kit (₹1,500). After that, it is just ₹1,500 per month.</p></details>
        </div>
      </section>

      <footer className="vi-footer">
        <div className="vi-wrap">
          <p>Vision Ignite is educational and not a medical treatment.</p>
          <p>© Forge Your Peak</p>
        </div>
      </footer>
    </main>
  );
};

export default VisionIgniteUPIMandate;
